<div>
  <app-nav-bar>
    <main class="container-main">
      <div
        class="row d-flex justify-content-between row-header-send align-items-end"
      >
        <div class="d-flex gap-8">
          <span class="screen-title">Gestão de clientes</span>
        </div>
        <div class="header-actions">
          <button
            class="btn btn-dark-primary-blue"
            type="button"
            (click)="refreshData()"
            [disabled]="isLoadingCards"
          >
            <img
              src="assets/icons/reload-icon.svg"
              width="20"
              height="20"
              alt="Atualizar"
            />
            Atualizar
          </button>
        </div>
      </div>

      <div class="content-wrapper">
        <div class="dashboard-cards-container">
          <mat-card
            class="summary-card"
            (click)="filterByStatus('NextToExpire')"
            style="cursor: pointer"
          >
            <mat-card-content>
              <div class="summary-card-top">
                <div class="summary-card-description">
                  <div class="card-icon card-icon-yellow">
                    <img
                      src="assets/icons/icon-loading-rotate.svg"
                      alt="Próximos a expirar"
                      width="24"
                      height="24"
                    />
                  </div>
                  <span class="card-label">Próximos a expirar</span>
                </div>
                <!--     <img
                  *ngIf="isLoadingCards"
                  src="assets/icons/loading-spinner.svg"
                  class="loading-spinner-mini"
                  alt="Loading"
                /> -->
              </div>
              <div class="card-value">
                <span class="value-number">{{ nextToExpire || 0 }}</span>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card
            class="summary-card"
            (click)="filterByStatus('Expired')"
            style="cursor: pointer"
          >
            <mat-card-content>
              <div class="summary-card-top">
                <div class="summary-card-description">
                  <div class="card-icon card-icon-red">
                    <img
                      src="assets/icons/icon-clock-timer.svg"
                      alt="Expirados"
                      width="24"
                      height="24"
                    />
                  </div>
                  <span class="card-label">Expirados</span>
                </div>
              </div>
              <div class="card-value">
                <span class="value-number">{{ expired || 0 }}</span>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card
            class="summary-card"
            (click)="filterByStatus('PendingDocument')"
            style="cursor: pointer"
          >
            <mat-card-content>
              <div class="summary-card-top">
                <div class="summary-card-description">
                  <div class="card-icon card-icon-yellow">
                    <img
                      src="assets/icons/warning-card-icon.svg"
                      alt="Com pendência"
                      width="24"
                      height="24"
                    />
                  </div>
                  <span class="card-label">Com pendência</span>
                </div>
              </div>
              <div class="card-value">
                <span class="value-number">{{ pendingDocument || 0 }}</span>
              </div>
            </mat-card-content>
          </mat-card>

          <mat-card
            class="summary-card"
            (click)="filterByStatus('NoLimit')"
            style="cursor: pointer"
          >
            <mat-card-content>
              <div class="summary-card-top">
                <div class="summary-card-description">
                  <div class="card-icon card-icon-red">
                    <img
                      src="assets/icons/icon-cash-pin.svg"
                      alt="Sem limite"
                      width="24"
                      height="24"
                    />
                  </div>
                  <span class="card-label">Sem limite</span>
                </div>
              </div>
              <div class="card-value">
                <span class="value-number">{{ noLimit || 0 }}</span>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="card-filters">
          <div class="header-filter">
            <h5>Filtros</h5>
          </div>
          <div class="content-filter">
            <form [formGroup]="filterForm">
              <div class="row">
                <div class="col">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Nome do cliente</mat-label>
                    <input
                      formControlName="name"
                      matInput
                      type="text"
                      placeholder="Digite o nome"
                    />
                  </mat-form-field>
                </div>

                <div class="col" *ngIf="filterForm.get('personType')?.value === 'Pf'">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>CPF</mat-label>
                    <input
                      formControlName="document"
                      matInput
                      type="text"
                      placeholder="Digite o CPF"
                      mask="000.000.000-00"
                      [clearIfNotMatch]="false"
                      autocomplete="off"
                    />
                  </mat-form-field>
                </div>

                <div class="col" *ngIf="filterForm.get('personType')?.value === 'Pj'">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>CNPJ</mat-label>
                    <input
                      formControlName="document"
                      matInput
                      type="text"
                      placeholder="Digite o CNPJ"
                      mask="AA.AAA.AAA/AAAA-00"
                      [clearIfNotMatch]="false"
                      uppercase
                      autocomplete="off"
                    />
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Tipo de Pessoa</mat-label>
                    <mat-select formControlName="personType">
                      <mat-option value="Pj">PJ - Pessoa Jurídica</mat-option>
                      <mat-option value="Pf">PF - Pessoa Física</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Situação Cadastral</mat-label>
                    <mat-select formControlName="situation">
                      <mat-option value="">Todos</mat-option>
                      <mat-option value="WAIT">Em andamento</mat-option>
                      <mat-option value="APPROVED">Aprovado</mat-option>
                      <mat-option value="REPROVED">Reprovado</mat-option>
                      <mat-option value="CANCELED">Cancelado</mat-option>
                      <mat-option value="IN_PROGRESS_REGISTER_MANAGEMENT"
                        >Enviando para Análise</mat-option
                      >
                      <mat-option
                        value="SENDING_REGISTRATION_REGISTER_MANAGEMENT"
                        >Em análise</mat-option
                      >
                      <mat-option value="PENDING">Com pendência</mat-option>
                      <mat-option value="AWAITING_CONSENT"
                        >Aceite de termos</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Agência</mat-label>
                    <mat-select formControlName="agency" #agencySelect>
                      <mat-option disabled class="search-option">
                        <ngx-mat-select-search
                          placeholderLabel="Pesquisar agência"
                          noEntriesFoundLabel="Nenhum resultado encontrado"
                          [formControl]="agencyFilterCtrl"
                        >
                        </ngx-mat-select-search>
                      </mat-option>

                      <mat-option value="">Todas</mat-option>

                      <mat-option
                        *ngFor="let ag of filteredAgencies | async"
                        [value]="ag.agencyNumber"
                      >
                        Ag {{ ag.agencyNumber }} - {{ ag.companyName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="status">
                      <mat-option value="">Todos</mat-option>
                      <mat-option value="Able">Apto a operar</mat-option>
                      <mat-option value="Expired">Expirado</mat-option>
                      <mat-option value="OnGoing">Em análise</mat-option>
                      <mat-option value="NoLimit">Sem limite</mat-option>
                      <mat-option value="Monitoring">Monitorar</mat-option>
                      <mat-option value="NextToExpire"
                        >Próx. a expirar</mat-option
                      >
                      <mat-option value="PendingIntegration"
                        >Não Integrado</mat-option
                      >
                      <mat-option value="SendingForAnalysis"
                        >Env. análise</mat-option
                      >
                      <mat-option value="PendingDocument"
                        >Com pendência</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Limite</mat-label>
                    <mat-select formControlName="limitType">
                      <mat-option value="">Todos</mat-option>
                      <mat-option value="Above50K">Acima de 50K</mat-option>
                      <mat-option value="Below50K">Abaixo de 50K</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Vencimento</mat-label>
                    <input
                      matInput
                      [matDatepicker]="picker"
                      formControlName="expireAt"
                      placeholder="Selecione a data"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <div class="buttons-filter">
                <button
                  type="button"
                  [style.width]="'134px'"
                  class="btn-outline-dark btn"
                  (click)="resetFilter()"
                  type="button"
                >
                  Limpar
                </button>

                <button
                  class="btn btn-dark-primary-blue"
                  type="button"
                  (click)="filterClients()"
                >
                  Filtrar
                </button>
              </div>
            </form>
          </div>
        </div>

        <div
          *ngIf="!haveClients && !showClientsError && !isLoadingClients"
          class="accordion-item painel painel-accordion no-clients"
        >
          <div class="img-no-clients">
            <img
              width="240"
              height="160"
              src="assets/image/no-order-icon.svg"
            />
          </div>

          <p id="txt-error-clients">
            Não foram encontrados clientes que correspondam aos filtros
            aplicados.
          </p>
        </div>

        <div *ngIf="isLoadingClients && !haveClients" class="box-order">
          <div
            class="padding-content"
            style="position: relative; min-height: 300px"
          >
            <div class="loading-overlay">
              <img
                src="assets/icons/loading-spinner.svg"
                class="loading-spinner-fullscreen"
                alt="Loading"
              />
            </div>
          </div>
        </div>

        <ng-container *ngIf="haveClients">
          <div class="box-order">
            <div class="padding-bottom-32 padding-top-10 header-box">
              <span class="mb-0"> Clientes cadastrados </span>
            </div>

            <div class="padding-content" style="position: relative">
              <app-table-clients-admin
                *ngIf="showTables && !isLoadingClients"
                [displayedColumns]="tableDisplayedColumns"
                [data]="clients"
                [pageNumber]="pageNumber"
                [pageSize]="pageSize"
                [totalElements]="totalElements"
                (pageChange)="updatePageData($event)"
              ></app-table-clients-admin>
            </div>
          </div>
        </ng-container>

        <div
          *ngIf="showClientsError"
          class="accordion-item painel painel-accordion error-orders"
        >
          <div class="img-error-orders">
            <img
              width="258"
              height="160"
              src="assets/image/error-order-icon.svg"
            />
          </div>

          <p id="txt-error-orders-register">
            Infelizmente encontramos um erro!
          </p>
          <p id="txt-error-order">
            Você pode aguardar uns instantes e tentar recarregar a <br />página
            mais uma vez.
          </p>

          <div class="btn-send-content">
            <button
              (click)="reloadPage()"
              class="btn btn-block mt-0 ml-3 btn-dark-primary-blue"
              type="button"
            >
              Tentar Novamente
            </button>
          </div>
        </div>
      </div>
    </main>
  </app-nav-bar>
</div>
